import React, { Component } from 'react';
import PropTypes from "prop-types";

class NextMeeting extends Component {
    static propTypes = {
        about: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired
    };

    render() {
        return (
            <div>
                <div className="container meeting">
                    <div className="jumbotron">
                        <h5 className="display-8 center">Next Meeting : {this.props.date}</h5>
                        <hr className="my-4" />
                        <h4 className="meeting-about">
                            {this.props.about}
                        </h4>
                    </div>
                </div>
            </div>
        );
    }
}

export default NextMeeting;



// WEBPACK FOOTER //
// ./src/components/nextMeeting.jsx